import React, { useContext, useEffect } from 'react';
import { Watermark, APIAlert } from '@mummssoftware/common-ui';
import { OrdersContext } from '../../context';
import { OrdersTable } from './OrdersTable';
import { Container } from '../../components/layout/WrapperDiv';

declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber?: string;
}>;

type OrdersProps = {
  patient?: mumms.patient;
  currentUser: mumms.User;
  appTitle?: string;
  smallWidget?: boolean;
  errorInfo?: mumms.ErrorInfo;
  clearError: () => void;
} & typeof RouteProps;

export const Orders = ({ smallWidget, errorInfo, clearError }: OrdersProps) => {
  const { watermark, onWidgetReady, startLoadingTime } = useContext(
    OrdersContext,
  );

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('Orders' as mumms.ComponentName);
    console.log('## COMPLETED ORDERS LOG WIDGET END ##', loadingDuration, 's');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container id="orders-container">
      <APIAlert errorInfo={errorInfo} handleClose={() => clearError()} />
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <OrdersTable smallWidget={smallWidget} />
    </Container>
  );
};

export default Orders;
